// Server-side event log shipper. POSTs every track() call to /api/log so the
// admin dashboard has a queryable record. Fire-and-forget by design — losing
// a single event is preferable to slowing the user down or surfacing an
// error.
//
// Authentication: when a user is signed in we attach their JWT so the server
// can attribute the row. Anonymous users still log; the row gets user_id=null
// and shows up in funnel/anonymous totals.

import { getAuth } from './auth/auth';

const API_BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? '/api';

export function log(event: string, props?: Record<string, unknown>): void {
  const jwt = getAuth().current()?.jwt;
  const headers: Record<string, string> = { 'content-type': 'application/json' };
  if (jwt) headers.authorization = `Bearer ${jwt}`;

  // No await — caller never blocks. Errors swallowed; we don't surface
  // analytics failures to the user.
  void fetch(`${API_BASE}/log`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ event, ...(props ? { props } : {}) }),
    credentials: 'include',
    keepalive: true, // lets the request finish even if the page is unloading
  }).catch(() => {
    /* swallow */
  });
}
